import { toast } from 'react-toastify'
import ToastModal from '../../breeder/toastModal/modalMessage'

export const handleChat = (dog) => {
  if (window.LiveChatWidget) {
    window.LiveChatWidget.call('maximize')
    window.LiveChatWidget.call('show_new_message', `I have a question about ${dog?.name} from ${dog?.breeder?.companyName} - Puppy ID #${dog?.id}`)
  }
}
export const handleReserve = (dog, router, dataApplication) => {
  if (dataApplication) {
    toast(
      <ToastModal
        message='You have already submitted an application for this puppy.'
        buttonTitle='View'
        onClick={() => {
          router.push(`/customer/applications/${dataApplication?.id}`)
        }}
      />
    )
  } else {
    router.push(`/customer/apply/${dog?.id}`)
      .then(() => window.scrollTo({ top: 0, behavior: 'smooth' }))
    if (window.ga?.getAll) {
      window.ga.getAll()[0].send('event', 'dog', 'apply', dog?.id)
    }
  }
}

export const handleCall = () => {
  // GTM call
  if (window.dataLayer) {
    window.dataLayer.push({ event: 'call' })
  }
  // UA call
  if (window.ga?.getAll) {
    window.ga.getAll()[0].send('event', 'call')
  }
}
